module.exports = __webpack_public_path__ + "img/33.10.pH.2fdc0f53.png";